import { useState, useEffect } from "react";
import episodeStore from "../../stores/episodeStore";
import statusStore from "../../stores/statusStore";
import Review from "./Review";
import MobileEpisodeReview from "../MobileComponents/MobileEpisodeReview";

export default function Episodes({selectedEpisode, setSelectedEpisode, selectedShow, selectedSeason, 
    episodes, seasonStatuses, episodeStatuses}) {
      
    const epStore = episodeStore();
    const staStore = statusStore();
    const [expandedEpisode, setExpandedEpisode] = useState();

    const [reviewOverlayOpen, setReviewOverlayOpen] = useState(false);

    useEffect(() => {
        staStore.fetchStatus();
    }, [reviewOverlayOpen]);

    return (
        <div>
             {!epStore.episode ? (
                    <p className="hint">Loading episodes…</p>
                ) : (
                <div className="seriesEpisodes">
                    {episodes?.filter(ep => Number(ep.seasonNumber) === Number(selectedSeason))
                    .map(ep => {
                        const episodeStatus = seasonStatuses.find(
                            (s) => s.episode === ep.episodeNumber
                        );
                        
                        return (
                            <div key={ep._id} className="episodeRow">
                                <img
                                    src={ep.image}
                                    alt={ep.title}
                                    className="episodeImg"
                                />
                                <div className="episodeContent">
                                    <div className="episodeHeader">
                                        <p className="episodeTitle">{ep.episodeNumber}. {ep.title}</p>
                                    </div>
                                    <p
                                        className={`episodeDescription ${
                                            expandedEpisode === ep._id ? "" : "clamp3"
                                        }`}
                                        onClick={() =>
                                            setExpandedEpisode(
                                            expandedEpisode === ep._id ? null : ep._id
                                            )
                                        }
                                        >
                                        {ep.description}
                                    </p>
                                    {episodeStatus ? (
                                        <div onClick={() => { setReviewOverlayOpen(true); 
                                                setSelectedEpisode({ ...ep, status: episodeStatus })}} 
                                                className="reviewListUl">
                                            <Review key={episodeStatus._id} review={episodeStatus} />
                                        </div>
                                    ) : ( 
                                        <button
                                            type="button"
                                            className="episodeStatusBtn"
                                            onClick={() => { setReviewOverlayOpen(true); 
                                                setSelectedEpisode({ ...ep, status: episodeStatus })}}
                                        >
                                            Mark as watched
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {reviewOverlayOpen && 
            <MobileEpisodeReview 
                selectedEpisode={selectedEpisode}
                reviewOverlayOpen={reviewOverlayOpen}
                setReviewOverlayOpen={setReviewOverlayOpen}
            ></MobileEpisodeReview>}
            
        </div>
    )
}